/**
 * Couleur associée à chaque type de pokémon (noms français, minuscules sans accent).
 * Utilisée pour la bordure et les badges des cartes du planning hebdomadaire.
 */
const COULEURS_TYPES = {
  normal: "#9099a1",
  combat: "#ce4069",
  vol: "#8fa8dd",
  poison: "#ab6ac8",
  sol: "#d97746",
  roche: "#c7b78b",
  insecte: "#90c12c",
  spectre: "#5269ac",
  acier: "#5a8ea1",
  feu: "#ff9d55",
  eau: "#4d90d5",
  plante: "#63bb5b",
  electrik: "#f3d23b",
  psy: "#f97176",
  glace: "#73cec0",
  dragon: "#0b6dc3",
  tenebres: "#5a5366",
  fee: "#ec8fe6",
}

const COULEUR_TYPE_PAR_DEFAUT = "#8b93ab"
const REGEX_DIACRITIQUES = /[̀-ͯ]/g

/**
 * Normalise un nom de type ("Ténèbres" -> "tenebres") pour la recherche.
 * @param {string} type
 * @returns {string}
 */
function normaliserType(type) {
  return String(type || "")
    .normalize("NFD")
    .replace(REGEX_DIACRITIQUES, "")
    .toLowerCase()
    .trim()
}

/**
 * Renvoie la couleur hexadécimale d'un type de pokémon.
 * @param {string} type
 * @returns {string}
 */
export function couleurDuType(type) {
  return COULEURS_TYPES[normaliserType(type)] || COULEUR_TYPE_PAR_DEFAUT
}
